//* 상주만 받는 페이지

import { FC, useEffect, useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { bugoByMemberIdStateSelectorFamily } from '@shared/api/bugo/bugo.selector';
import {
  useCourtesyAssetListByMemberHook,
  useCourtesyContentListByMemberHook,
} from '@shared/api/courtesyAsset/courtesyAsset.hook';
import { CourtesyContent } from '@shared/api/courtesyAsset/courtesyAsset.interface';
import { Loading } from '@shared/components/Loading';
import { useRedirect } from '@shared/hooks/useRedirect';
import { notificateError } from '@shared/plugIn/ant-notification/ant-notifiaction';
import { notificationInstanceAtom } from '@shared/state/atom/notification.atom';
import { Location, useParams } from 'react-router-dom';

import { MemberCourtesySender } from '../containers/MemberCourtesy/MemberCourtesySender';
import { useCourtesyOutletContext } from '../hooks/useCourtesyAccess';
import { useTitleHook } from '../hooks/useTitleHook';

export interface ILocationState extends Location {
  state: {
    tab?: number;
    courtesyContent?: CourtesyContent;
  } | null;
}

const CourtesySenderPage: FC = () => {
  useRedirect();
  useTitleHook('답례인사', ' ', undefined, true, undefined, false);
  const { memberId } = useParams<{ memberId?: string }>();
  const memberId_ = memberId ?? 'undefined';
  useCourtesyAssetListByMemberHook(`${memberId}`);
  useCourtesyContentListByMemberHook(`${memberId}`);

  // 기간이 지난 부고면 고인·상주 정보 없이 렌더 (게이트가 판정해 내려준다)
  const { anonymous } = useCourtesyOutletContext();

  const bugoByMemberIdState = useRecoilValue(
    bugoByMemberIdStateSelectorFamily(memberId_),
  );
  console.log('bugoByMemberIdState', bugoByMemberIdState);
  const notifiacationInstance = useRecoilValue(notificationInstanceAtom);

  // memberId가 없거나 잘못된 형식일 경우 404.
  useEffect(() => {
    if (bugoByMemberIdState.status === 'error') {
      notificateError(notifiacationInstance, '해당 부고를 찾을 수 없습니다.');
    }
  }, [bugoByMemberIdState.status, notifiacationInstance]);

  const mainContent = useMemo(() => {
    if (bugoByMemberIdState.status === 'success' && bugoByMemberIdState.data) {
      return (
        <MemberCourtesySender bugo={bugoByMemberIdState.data} anonymous={anonymous} />
      );
    } else {
      return (
        <div className="center-box h-screen-15">
          <Loading />
        </div>
      );
    }
  }, [anonymous, bugoByMemberIdState.data, bugoByMemberIdState.status]);

  return <div>{mainContent}</div>;
};

export default CourtesySenderPage;
